import { useLayoutEffect, useState } from 'react';

export type WindowSizeType = {
  w: number; //画面全体の幅
  h: number; //画面全体の高さ
  _w: number; //画面内の特定の領域の幅
  _h: number; //画面内の特定の領域の高さ
};

// 画面サイズの変更を検知してstate更新するhooks
// https://zenn.dev/kenghaya/articles/6020b6192dadec
export const useWindowSize = (
  horizontalRate = 1, //特定領域の幅の全体に対する割合
  verticalRate = 1, //特定領域の高さの全体に対する割合
  initWidth = window.innerWidth,
  initHight = window.innerHeight
) => {
  const [size, setSize] = useState<WindowSizeType>({
    w: initWidth,
    h: initHight,
    _w: initWidth * horizontalRate,
    _h: initHight * verticalRate
  });
  useLayoutEffect(() => {
    const updateSize = (): void => {
      setSize({
        w: window.innerWidth,
        h: window.innerHeight,
        _w: window.innerWidth * horizontalRate,
        _h: innerHeight * verticalRate
      });
    };

    window.addEventListener('resize', updateSize);
    updateSize();

    return () => window.removeEventListener('resize', updateSize);
  }, [horizontalRate, verticalRate]);
  return { size };
};
